<template>
  <div>
    <span v-if="loading">大小：检测中...</span>
    <span v-else>大小：{{ mbText }}</span>

    <div v-if="!loading && mb > limitMb" class="size-alert">
      <van-icon name="warning-o" class="alert-icon" style="display: inline-block;vertical-align: middle;"/>
      <span class="alert-text">文件大于 {{ limitMb }}MB，可能提交失败。</span>
    </div>
  </div>
  
</template>

<script>
import axios from "axios";
import common from "../assets/js/common";

const BYTES_PER_MB = 1024 * 1024;

export default {
  name: "FileSizeCheck",
  props: {
    url: { type: String, required: true },
    limit: { type: Number, default: 8 },
  },
  data() {
    return { mb: 0, loading: true, limitMb: this.limit };
  },
  watch: {
    url: {
      immediate: true,
      handler() {
        this.fetch();
      },
    },
    limit(val) {
      this.limitMb = Number(val) || 8;
    },
  },
  computed: {
    mbText() {
      const n = Number(this.mb);
      return (isNaN(n) ? 0 : n).toFixed(2) + "MB";
    },
  },
  methods: {
    resolveUrl(url) {
      if (!url) {
        return "";
      }
      if (url.indexOf("http") !== -1) {
        return url;
      }
      return common.dynamicHost() + url;
    },
    fetch() {
      const targetUrl = this.resolveUrl(this.url);
      if (!targetUrl) {
        this.loading = false;
        this.mb = 0;
        return;
      }
      this.loading = true;
      axios
        .head(targetUrl)
        .then((res) => {
          const len = res.headers["content-length"];
          this.mb = len ? Number(len) / BYTES_PER_MB : 0;
        })
        .catch(() => {
          this.mb = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.size-alert{
  display: block;
  margin-top: 6px;
  padding: 8px 10px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  color: #a8071a;
  border-radius: 6px;
}
.alert-icon{
  color: #ff4d4f;
  margin-right: 6px;
}
.alert-text{
  vertical-align: middle;
}
</style>

